import { Flex, Title, Text } from "@mantine/core";
import {
  ENUMPOASteps,
  usePOAStepsStore,
} from "../../../hooks/ui/poaStepsDataStore";
import { useUpdateCustomerData } from "../../../hooks/ui/";
import { useEffect, useCallback } from "react";
import { REPLAY_BLOCK_CLASS } from "../../../utils/statsig";

const YCBM_ORIGINS = [
  "https://sambla-pension.youcanbook.me",
  "https://sambla-dev.youcanbook.me",
];

// Only the staging build points VITE_YCBM_URL at the same-origin mock page (a relative path),
// so only there may a same-origin message confirm the booking.
const isTrustedBookingOrigin = (origin: string) =>
  YCBM_ORIGINS.includes(origin) ||
  (Boolean(import.meta.env.VITE_YCBM_URL?.startsWith("/")) &&
    origin === window.location.origin);

export default function AdvisoryBooking() {
  const { customerData } = useUpdateCustomerData();
  const { setStep } = usePOAStepsStore();

  const checkBookingMessage = useCallback(
    (e: MessageEvent) => {
      if (isTrustedBookingOrigin(e.origin)) {
        if (e.data?.message?.data === "/thanks") {
          setStep(ENUMPOASteps.POASUMMARY);
        }
      }
    },
    [setStep],
  );

  useEffect(() => {
    window.addEventListener("message", (e) => checkBookingMessage(e));

    return () => {
      window.removeEventListener("message", (e) => checkBookingMessage(e));
    };
  }, [checkBookingMessage]);

  return (
    <Flex justify="center" align="center">
      <Flex direction="column" maw={672} w={"100%"}>
        <Title order={2} mb="1rem" ff="var(--wallet-font-family-sambla-sans)">
          När vill du att vi ringer dig för rådgivning?
        </Title>
        <Text mb="1rem">
          När vi har analyserat din pension kontaktar vi dig för ett
          kostnadsfritt rådgivningssamtal. Vi går tillsammans igenom din pension
          och ser över hur du kan förbättra ditt sparande utifrån dina behov och
          mål.
        </Text>
        <iframe
          title="YoucanBookMe"
          className={REPLAY_BLOCK_CLASS}
          style={{
            height: "80vh",
            width: "100%",
            border: "none",
          }}
          src={`${import.meta.env.VITE_YCBM_URL}/?EMAIL=${customerData.email}&FNAME=${customerData.firstName}&LNAME=${customerData.lastName}&TREF=${customerData.booking?.bookingId}`}
        />
      </Flex>
    </Flex>
  );
}
